import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    OnDestroy,
    Input,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { FiltrosService } from "app/main/apps/shared/services/util/filtros.service";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Subscription, Observable } from "rxjs";
import { ClienteDTO } from "../../../../shared/interfaces/cliente.interface";
import { startWith, map } from "rxjs/operators";
import { ElementRef, ViewChild } from "@angular/core";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

import { EstadoDTO } from "app/main/apps/shared/interfaces/estado.interface";

import { FiltroCotizaciones } from "app/main/apps/shared/interfaces/filtro-cotizaciones.interface";
const NOMBREFILTRO = "filtrosCotizaciones";
@Component({
    selector: "app-filtro-cotizacion",
    templateUrl: "./filtro-cotizacion.component.html",
    styleUrls: ["./filtro-cotizacion.component.scss"],
})
export class FiltroCotizacionComponent implements OnInit, OnDestroy {
    @ViewChild("clienteInput") clienteInput: ElementRef<HTMLInputElement>;
    @ViewChild("vigenciaInput") vigenciaInput: ElementRef<HTMLInputElement>;
    @ViewChild("situacionInput") situacionInput: ElementRef<HTMLInputElement>;

    @Input() clientes: ClienteDTO[];
    @Input() vigencias: EstadoDTO[];
    @Input() situaciones: EstadoDTO[];
    @Input() setearFiltros: boolean;

    @Output()
    filtrarCotizaciones: EventEmitter<FiltroCotizaciones> = new EventEmitter();
    filtros: FiltroCotizaciones;
    separatorKeysCodes: number[] = [ENTER, COMMA];
    subscripciones: Subscription;

    clienteCtrl = new FormControl();
    vigenciaCtrl = new FormControl();
    situacionCtrl = new FormControl();

    filteredClientes: Observable<ClienteDTO[]>;
    filteredVigencia: Observable<EstadoDTO[]>;
    filteredSituacion: Observable<EstadoDTO[]>;
    constructor(
        private _filtroSrvc: FiltrosService,
        public _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this.subscripciones = new Subscription();
        this.filtros = this._filtroSrvc.getFiltro(NOMBREFILTRO);

        this.filteredClientes = this.clienteCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "nombre", this.clientes)
                    : this.clientes.slice()
            )
        );

        this.filteredVigencia = this.vigenciaCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "descripcion", this.vigencias)
                    : this.vigencias.slice()
            )
        );

        this.filteredSituacion = this.situacionCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "descripcion", this.situaciones)
                    : this.situaciones.slice()
            )
        );
    }

    ngOnInit(): void {
        //console.log("setearFiltros", this.setearFiltros);
        //console.log(this.vigencias);
        this.subscripciones.add(
            this._filtroSrvc.filtrosCotizacionesLoaded$.subscribe((filtros) => {
                //console.log("filtrosssss", filtros);
                this.filtros = filtros;
            })
        );
    }

    agregarFiltro(
        event: MatChipInputEvent,
        controller: any,
        filtroSeleccionado: string
    ) {
        const input = event.input;
        const value = event.value;

        if ((value || "").trim()) {
            this._filtroSrvc.setFiltro(
                NOMBREFILTRO,
                filtroSeleccionado,
                value.trim().toLowerCase(),
                value.trim().toLowerCase()
            );
        }

        if (input) {
            input.value = "";
        }

        controller.setValue(null);
    }

    quitarFiltro(nombreFiltro: string) {
        this._filtroSrvc.resetFiltro(NOMBREFILTRO, nombreFiltro);
    }

    seleccionarFiltro(
        event: MatAutocompleteSelectedEvent,
        columnaValor: string,
        columnaDescripcion: string,
        controller: any,
        input: string,
        filtroSeleccionado: string
    ) {
        //console.log(event.option.value);

        const valor = event.option.value[columnaValor];
        const descripcion = event.option.value[columnaDescripcion];

        this._filtroSrvc.setFiltro(
            NOMBREFILTRO,
            filtroSeleccionado,
            valor,
            descripcion
        );
        this[input].nativeElement.value = "";
        controller.setValue(null);
        this.filtros = this._filtroSrvc.getFiltro(NOMBREFILTRO);
    }
    limpiarTodosFiltros() {
        this._filtroSrvc.initFiltrosCotizaciones();
        this.filtros = this._filtroSrvc.getFiltro(NOMBREFILTRO);
        this.filtrar();
    }

    private _filter(
        value: string | any,
        columnaAFiltrar: string,
        listaDeValoresAfiltrar: any[]
    ): any[] {
        //console.log(value);
        //console.log(columnaAFiltrar);
        let filterValue: string;
        if (typeof value === "object") {
            filterValue = value[columnaAFiltrar].toLowerCase();
        } else {
            filterValue = value.toLowerCase();
        }

        return listaDeValoresAfiltrar.filter((item) =>
            item[columnaAFiltrar].toLowerCase().includes(filterValue)
        );
    }

    filtrar() {
        this.filtrarCotizaciones.emit(this.filtros);
    }
    ngOnDestroy() {
        this.limpiarTodosFiltros();
        this.subscripciones.unsubscribe();
        //console.log("destoyed filtros cotizaciones!");
    }
}
